<template>
    <div class="v-dropdown">
        <button class="btn" :class="[btnVariant,buttonClass]" v-on:click="$emit('input',!value)">
            <feather-icon v-if="icon" :icon="icon" class="mr-50"></feather-icon>
            {{buttonText}}
            <feather-icon v-if="arrow" class="ml-25" :icon="value ? 'ChevronUpIcon':'ChevronDownIcon'"></feather-icon>
        </button>
        <transition name="fade">
            <div v-show="value" class="v-dropdown-content py-50 border rounded bg-white shadow" no-body>
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
export default {
    components:{
        BCard
    },
    props:{
        value:{
            type:Boolean,
            default:true
        },
        variant:{
            type:String,
            default:"primary"
        },
        buttonClass:{
            type:String,
            default:""
        },
        buttonText:{
            type:String,
            default:""
        },
        arrow:{
            type:Boolean,
            default:true
        },
        icon:{
            type:String,
            default:null
        }
    },
    computed:{
        btnVariant(){
            return ["btn",this.variant].join("-")
        },
    }

}
</script>

<style lang="scss">
.v-dropdown{
    position: relative;

    .v-dropdown-content{
        margin-top: 0.5rem;
        position: absolute;
        z-index: 999;
        width: 320px;
    }

    @media screen and(max-width:500px) {
        .v-dropdown-content{
            width: 250px;
        }
    }
}
</style>